/* eslint-disable import/prefer-default-export */
import { repProxyTokensUrl } from '../urls';
import refresh from '../refresh';

export async function getRepProxyTokens(artistId) {
  return refresh(async () => {
    const response = await fetch(`${repProxyTokensUrl}?artist=${artistId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
